<template>
  <w-sliding-popup ref="slidingPopup" type="setting" :title="popupTitle" @close="closePopup" width="500px">
    <div slot="content">
      <w-search-field class="mr-b10" ref="searchField" @search="searchKeword"/>
      <el-tree ref="apmTree" :data="apmTreeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" highlight-current default-expand-all :filter-node-method="filterNode" @node-click="clickNode" />
    </div>
    <div slot="footer">
      <el-button :disabled="!isAbleSave" size="large" type="solid" @click="updateGroupInfo">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapState } from 'vuex';
import { isNil, map, partialRight, pick } from 'lodash';
import { defaultProps } from '@/constants/tree';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';
import WSearchField from '@/components/form/SearchField';

const titleType = { biz: '비즈니스', application: '어플리케이션 티어', instance: '인스턴스 티어' };
const nodeId = { biz: 'keyTrsId', application: 'applicationId', instance: 'instanceId' };

export default {
  name: 'WGroupChangePopup',
  components: {
    WSearchField,
  },
  props: {
    currentTreeType: String,
    selectionNodes: Array, // 목록에서 선택된 데이터
    selectedConfigTreekey: String, // apm 트리에서 선택된 그룹 treeKey
  },
  data() {
    return {
      defaultProps,
      popupTitle: '그룹 변경 팝업',
      isAbleSave: false,
      currentNode: null,
    };
  },
  computed: mapState({
    apmTreeData: (state) => state.apm.treeData,
  }),
  watch: {
    currentTreeType: {
      handler() {
        if (!isNil(this.currentTreeType)) {
          this.popupTitle = `${titleType[this.currentTreeType]} 변경`;
        }
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        if (!isNil(this.selectedConfigTreekey)) {
          this.$refs.apmTree.setCurrentKey(this.selectedConfigTreekey);
        }
      });
    },
    closePopup() {
      this.$refs.searchField.clear();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * [clickNode 좌측 트리에서 선택한 그룹이 변경 팝업 오픈시 선택되도록 설정한다.]
     * @author yelim
     */
    clickNode(node) {
      this.currentNode = node;
      this.isAbleSave = node.type === 'group' && node.treeKey !== this.selectedConfigTreekey;
    },
    /**
     * [updateGroupInfo 티어변경/ 비즈니스 변경을 수행한다.]
     * @author yelim
     */
    updateGroupInfo() {
      const treeType = this.currentTreeType;
      const currentNode = this.currentNode;
      const updateInfoList = map(this.selectionNodes, partialRight(pick, nodeId[treeType]));
      const defaultParams = { treeType, updateInfoList };

      // 선택한 트리타입에 따라 다른 groupId가 매핑되어야 하므로 분기처리
      const params = treeType === 'biz' ? { bizId: currentNode.bizId, ...defaultParams } : { tierType: treeType.toUpperCase(), tierId: currentNode.tierId, ...defaultParams };
      ApmSettingAPI.updateGroupInfo(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.$emit('reloadData');
          this.closePopup();
        }
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, titleType[treeType], result.success));
      });
    },
    /**
     * 트리 검색
     * @param  {[type]} keyword [description]
     * @return {[type]}         [description]
     * @author jda
     */
    searchKeword(keyword) {
      this.$refs.apmTree.filter(keyword);
    },
    /**
     * 트리 필터 메소드
     * @param  {[type]} value [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     * @author jda
     */
    filterNode(value, data) {
      if (!value) return true;

      const keyword = value.toLowerCase();
      return data.label.toLowerCase().indexOf(keyword) !== -1;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/popup/GroupChangePopup.vue